const myCampaignsPage = {
  notFoundCampaigns: 'Кампаний не найдено',
  editingDisabled: 'Редактирование устаревшей кампании отключено. Пожалуйста, отредактируйте кампанию на устаревшей платформе',
  startDisabled: 'Запуск устаревшей кампании отключен. Пожалуйста, запустите кампанию на устаревшей платформе',
  header: {
    toolbar: {
      all: 'Все',
      active: 'Активный',
      pause: 'Остановление',
      draft: 'Черновик',
      delayed: 'Задержка',
      failed: 'Не удалось',
      completed: 'Завершенный',
      canceled: 'Отменено',
      archived: 'В архиве',
      moderation: 'Модерация',
      pending: 'Ожидает',
      rejected: 'Отклонено'
    }
  },
  table: {
    myCampaigns: 'Мои кампании',
    showing: 'Показаны',
    campaignsOf: 'кампании',
    found: 'Найденный',
    campaignFrom: 'кампания(и) от',
    nothingFoundBySearch: 'Поиском ничего не нашел',
    noCampaignsFound: 'Кампаний не найдено',
    noOrdersFound: 'Заказов не найдено',
    noAdvertisingFound: 'Рекламы не найдены',
    showAll: 'показать все',
    showMore: 'показать больше',
    showDetails: 'показать детали',
    details: 'детали',
    spreadInstallsFor24h: 'Распространение установок за 24 часа',
    showReviews: 'Показать отзывы',
    promotionRuleStopsPromotionIfRankReachedRequiredLevel: 'Правило повышения останавливает продвижение, если ранг достиг необходимого уровня',
    installsDeliveryType: 'Устанавливает тип доставки',
    vendor: 'Поставщик',
    changeVendor: 'Сменить поставщика'
  },
  tableDropdown: {
    quickActions: 'Меню быстрых действий',
    exportCampaigns: 'Экспорт кампаний',
    archiveAll: 'Заархивируй все',
    refresh: 'Обновить',
  },
  actionsDropdown: {
    start: 'Начать',
    startNow: 'Начать сейчас',
    pause: 'Пауза',
    cancel: 'Отмена',
    archive: 'Архив',
    edit: 'Редактировать',
    update: 'Обновить',
    details: 'Детали',
    resume: 'Восстановить',
    repeat: 'Повторение',
    clone: 'Клонувати',
    reject: 'Отклонить',
    moderation: 'Отправить на модерацию',
    sendMessage: 'Отправить сообщение',
    forcedCompletion: 'Принудительное завершение',
    forcedDraft: 'Принудительный черновик',
  },
  modalReview: {
    title: 'Мои отзывы о кампании',
    exportReviews: 'Экспорт отзывов'
  }
};
export default myCampaignsPage;
